// English strings (source language): watching a race again.

const en = {
  badge: 'Replay',
  loading: 'Loading the replay…',
  loadingHelp: 'The race is rebuilt from its recording.',
  notFound: 'No replay for this activity: only races are recorded, and the server keeps your last twenty.',
  play: 'Play',
  pause: 'Pause',
  seek: 'Position in the race',
  speed: 'Speed',
  follow: 'Rider to follow',
  exit: 'Leave the replay',
};
export default en;
